import React from 'react';
import { withFormsy } from 'formsy-react';

import { type FieldProps } from './components/BaseTextField';
import withFormsyValidations from './components/WithFormsyValidations';
import SimpleTextField from './SimpleTextField';

type PhoneNumberFieldProps = Omit<FieldProps<string>, 'startAdornment' | 'endAdornment'>;

/** An input component used to display and edit phone numbers */
function PhoneNumberField(props: PhoneNumberFieldProps) {
	const handleChange = (name, newValue) => {
		props.setValue(newValue);
		props.sendChange(name, newValue);
	};

	return <SimpleTextField {...props} type="tel" sendChange={handleChange} />;
}

export default withFormsyValidations(withFormsy(PhoneNumberField), {
	validations: { isPhoneNumber: true },
	validationErrors: ({ t }) => ({ isPhoneNumber: t('ERROR_TEXT_PHONE') })
});
